import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, Row, Typography, UploadFile, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ShippingList from "./ShippingList";
import { useLoadTransportationAll } from "hooks/useFactory";
import FooterShipping from "./FooterShippong";
import { useAppSelector } from "store";
import SelectShippingType from "./SelectShippingType";

const SettingShipping = () => {
  const navigate = useNavigate();

  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const { data: dataTransportation, refetch: refetchData } =
    useLoadTransportationAll({
      search: "",
      price_rate: 0,
      service_price: 0,
      transport_type: "",
      factory_id: factoryId || "",
    });
  return (
    <WrapperAll>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/setting");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>จัดการค่าจัดส่ง</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <SelectShippingType />
            <ShippingList
              data={dataTransportation}
              refetch={refetchData}
              // refetchTo={refetchData}
            />
          </Card>
        </Col>
      </Row>
    </WrapperAll>
  );
};

export default SettingShipping;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: #efefef;
`;
